function toggleTheme() {
    return {
        type: 'TOGGLE_THEME'
    }
}

export default toggleTheme;